module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-admin-form table wh100 table-w-0-100\">\n	<div>\n		<div class=\"gl-admin-form__menu cell__top h100\">\n			<div class=\"cell__abs_container\">\n				<div name=\"menu\" class=\"cell__abs overflow-y__auto\"></div>\n			</div>\n		</div>\n		<div class=\"h100\">\n			<div class=\"cell__abs_container\">\n				<div class=\"cell__abs\" name=\"section\">\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}